export type EnumType = 'generated' | 'used' | 'stored' | 'supplied';

type ImgType = {
    pc: string;
    h5: string;
};

export type ListType = {
    img: ImgType;
    title: string;
    desc: string;
    power?: string | undefined;
    icon: EnumType;
    bgColor: string;
    code: string;
    appliances?: string | undefined;
};

type I18nType = {
    [key: 'us' | 'ca' | 'eu' | 'uk' | 'de' | 'fr' | 'it' | 'es' | 'jp' | 'kr' | 'au' | 'za']: {
        title: string;
        desc: string;
        items: ListType[];
    };
};

export const I18n: I18nType = {
    us: {
        title: 'Review Your EcoFlow Power Journey with a Million Moments of Gratitude\nJoin in to get an exclusive gift package!',
        desc: 'EcoFlow is revolutionizing the energy experience through an integrated system that combines cutting-edge software and hardware. Our cloud-based Energy Management System (EMS) spans a user-friendly app, web interface, and smart monitor, providing control across various scenarios and platforms. With intelligent features and data-driven predictions, our solution enhances energy efficiency and cost savings, reshaping the end-to-end energy experience.',
        nextBtn: 'Next',
        items: [
            {
                img: {
                    pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709704930991/1.jpg',
                    h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709711627922/1.jpg',
                },
                title: "By using [appliances],\nyou've generated approximately [power] of electricity",
                desc: "That's an estimated carbon saving of 390 g per kWh, you've contributed to a total reduction of [carbon] carbon emissions. Your commitment to sustainability is making a significant impact!",
                power: '',
                icon: 'generated',
                bgColor: 'linear-gradient(180deg, #3F68E0 20%, rgba(0, 0, 0, 0.30) 100%)',
                code: 'Eco_Credits_Day_Solar',
            },
            {
                img: {
                    pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709705023608/2.jpg',
                    h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709711650061/2.jpg',
                },
                title: "By using [appliances],\nyou've used approximately [power] of power,",
                desc: 'confidently running your household with a continuous energy supply.',
                power: '',
                icon: 'used',
                bgColor: 'linear-gradient(180deg, #FFBD3C 20%, rgba(0, 0, 0, 0.10) 100%)',
                code: 'Eco_Credits_Day_Storge',
            },
            {
                img: {
                    pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709705050961/3.jpg',
                    h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709711672442/3.jpg',
                },
                title: "By utilizing [appliances],\nyou've stored a total of [power].",
                desc: "Proactively storing energy for your home, you've brought immense peace of mind to your household through advanced power storage.",
                power: '',
                icon: 'stored',
                bgColor: 'linear-gradient(180deg, #31BF01 20%, rgba(0, 0, 0, 0.30) 100%)',
                code: 'Eco_Credits_Day_Usage',
            },
            {
                img: {
                    pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709705128406/4.jpg',
                    h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709711716499/4.jpg',
                },
                title: "By utilizing Ecoflow [appliances],\nyou've already supplied your home with approximately [power].",
                desc: 'Experience both energy efficiency and savings for your household.',
                power: '',
                icon: 'supplied',
                bgColor: 'linear-gradient(180deg, #3F68E0 20%, rgba(0, 0, 0, 0.30) 100%)',
                code: 'Eco_Credits_Day_WN_Usage',
            },
        ] as ListType[],
    },
    de: {
        title: 'Lassen Sie Ihre EcoFlow Energiereise noch einmal Revue passieren.\nMachen Sie mit und erhalten Sie ein exklusives Geschenkpaket!',
        desc: 'EcoFlow revolutioniert das Energiemanagement durch ein integriertes System, das modernste Soft- und Hardware kombiniert. Unser cloudbasiertes Energiemanagementsystem (EMS) umfasst eine benutzerfreundliche App, ein Webinterface und einen Smart Monitor und ermöglicht die Steuerung verschiedener Szenarien und Plattformen. Dank intelligenter Funktionen und datengestützter Prognosen steigert unsere Lösung die Energieeffizienz und ermöglicht Kosteneinsparungen.',
        nextBtn: 'Weiter',
        items: [
            {
                img: {
                    pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709704930991/1.jpg',
                    h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709711627922/1.jpg',
                },
                title: 'Durch den Einsatz von [appliances],\nhaben Sie [power] Strom erzeugt',
                desc: 'Bei einer geschätzten CO2-Einsparung von 0,39 kg pro kWh haben Sie zu einer Gesamtreduktion der CO2-Emissionen um [carbon] beigetragen. Ihr Engagement für Nachhaltigkeit zeigt Wirkung!',
                power: '',
                icon: 'generated',
                bgColor: 'linear-gradient(180deg, #3F68E0 20%, rgba(0, 0, 0, 0.30) 100%)',
                code: 'Eco_Credits_Day_Solar',
            },
            {
                img: {
                    pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709705023608/2.jpg',
                    h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709711650061/2.jpg',
                },
                title: 'Durch den Einsatz von [appliances]\nhaben Sie eine zuverlässige Stromversorgung von [power] für Ihr,',
                desc: 'Zuhause erreicht. Sichern Sie auch weiterhin die kontinuierliche Stromversorgung Ihres Haushalts durch den Einsatz von EcoFlow Produkten.',
                power: '',
                icon: 'used',
                bgColor: 'linear-gradient(180deg, #FFBD3C 20%, rgba(0, 0, 0, 0.10) 100%)',
                code: 'Eco_Credits_Day_Storge',
            },
            {
                img: {
                    pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709705050961/3.jpg',
                    h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709711672442/3.jpg',
                },
                title: 'Durch den Einsatz von [appliances] \nhaben Sie insgesamt [power] gespeichert.',
                desc: 'Mit der proaktiven Energiespeicherung für Ihr Haus haben Sie Ihren Haushalt durch fortschrittliche Energiespeicherung abgesichert.',
                power: '',
                icon: 'stored',
                bgColor: 'linear-gradient(180deg, #31BF01 20%, rgba(0, 0, 0, 0.30) 100%)',
                code: 'Eco_Credits_Day_Usage',
            },
            {
                img: {
                    pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709705128406/4.jpg',
                    h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709711716499/4.jpg',
                },
                title: 'Durch den Einsatz von EcoFlow PowerStream haben Sie Ihr Zuhause bereits mit ca.\n[power] versorgt.',
                desc: 'Sie erleben sowohl Energieeffizienz als auch Einsparungen für Ihren Haushalt.',
                power: '',
                icon: 'supplied',
                bgColor: 'linear-gradient(180deg, #3F68E0 20%, rgba(0, 0, 0, 0.30) 100%)',
                code: 'Eco_Credits_Day_WN_Usage',
            },
        ] as ListType[],
    },
    fr: {
        title: "Votre expérience nous guide dans l'amélioration continue de nos produits et\nservices. Participez à notre questionnaire et gagnez un coffret cadeau exclusif !",
        desc: "EcoFlow révolutionne votre gestion énergétique avec un système intégré alliant logiciel et matériel de pointe. Notre solution cloud inclut une application intuitive, une interface web et un suivi intelligent pour un contrôle optimal sur différents scénarios et plateformes. Dotée de fonctionnalités avancées et de prévisions basées sur les données, notre approche optimise l'efficacité énergétique et réduit les coûts, transformant ainsi votre expérience énergétique de manière globale.",
        nextBtn: 'Suivant',
        items: [
            {
                img: {
                    pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709704930991/1.jpg',
                    h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709711627922/1.jpg',
                },
                title: "Grâce à l'utilisation de [appliances],\nvous avez produit environ [power] d'électricité",
                desc: 'réduisant les émissions de CO2 de [carbon](390 g par 1 kWh généré). Votre engagement pour le développement durable a donc un impact significatif !',
                power: '',
                icon: 'generated',
                bgColor: 'linear-gradient(180deg, #3F68E0 20%, rgba(0, 0, 0, 0.30) 100%)',
                code: 'Eco_Credits_Day_Solar',
            },
            {
                img: {
                    pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709705023608/2.jpg',
                    h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709711650061/2.jpg',
                },
                title: "En utilisant[appliances],\nvous avez consommé [power] d'énergie.",
                desc: 'Ce résultat remarquable contribue directement à un avenir plus durable.',
                power: '',
                icon: 'used',
                bgColor: 'linear-gradient(180deg, #FFBD3C 20%, rgba(0, 0, 0, 0.10) 100%)',
                code: 'Eco_Credits_Day_Storge',
            },
            {
                img: {
                    pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709705050961/3.jpg',
                    h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709711672442/3.jpg',
                },
                title: 'En utilisant [appliances],\nvous avez stocké un total de [power]: ',
                desc: "vous êtes bien équipé pour faire face à toute situation d'urgence !",
                power: '',
                icon: 'stored',
                bgColor: 'linear-gradient(180deg, #31BF01 20%, rgba(0, 0, 0, 0.30) 100%)',
                code: 'Eco_Credits_Day_Usage',
            },
            {
                img: {
                    pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709705128406/4.jpg',
                    h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709711716499/4.jpg',
                },
                title: "Grâce à l'EcoFlow PowerStream, \nvous avez alimenté votre foyer avec environ [power],",
                desc: "augmentant ainsi votre autonomie énergétique et réalisant des économies importantes sur vos factures d'électricité.",
                power: '',
                icon: 'supplied',
                bgColor: 'linear-gradient(180deg, #3F68E0 20%, rgba(0, 0, 0, 0.30) 100%)',
                code: 'Eco_Credits_Day_WN_Usage',
            },
        ] as ListType[],
    },
    it: {
        title: 'Ripercorri il tuo viaggio energetico con EcoFlow con un milione di momenti di gratitudine\nIscriviti per ricevere un pacchetto regalo esclusivo!',
        desc: 'EcoFlow sta rivoluzionando il mondo energetico con un sistema integrato che sfrutta software e hardware all’avanguardia. Il nostro sistema di gestione dell’energia basato su cloud include un’app intuitiva, un’interfaccia web e uno schermo intelligente, e ti offre il controllo di piattaforme e attività diverse. Con una funzionalità intelligente e stime sui consumi basate sui dati, la soluzione EcoFlow aumenta l’efficienza energetica e i risparmi, regalandoti un’esperienza completamente nuova.',
        nextBtn: 'Avanti',
        items: [
            {
                img: {
                    pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709704930991/1.jpg',
                    h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709711627922/1.jpg',
                },
                title: 'Con [appliances],\nhai generato circa [power] di elettricità',
                desc: 'Considerando un risparmio di 390 g di carbonio per kWh, le tue scelte energetiche hanno portato a una riduzione di [carbon] emissioni di carbonio. Il tuo impegno per la sostenibilità ha un impatto importante!',
                power: '',
                icon: 'generated',
                bgColor: 'linear-gradient(180deg, #3F68E0 20%, rgba(0, 0, 0, 0.30) 100%)',
                code: 'Eco_Credits_Day_Solar',
            },
            {
                img: {
                    pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709705023608/2.jpg',
                    h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709711650061/2.jpg',
                },
                title: 'Con [appliances],\nhai utilizzato circa [power] odi energia e alimentato la casa senza sosta e in modo sicuro.',
                desc: '',
                power: '',
                icon: 'used',
                bgColor: 'linear-gradient(180deg, #FFBD3C 20%, rgba(0, 0, 0, 0.10) 100%)',
                code: 'Eco_Credits_Day_Storge',
            },
            {
                img: {
                    pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709705050961/3.jpg',
                    h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709711672442/3.jpg',
                },
                title: 'Utilizzando [appliances],\nhai accumulato un totale di [power].',
                desc: 'Immagazzinare l’energia per la casa in modo proattivo permette a te e la tua famiglia di stare sempre in tranquillità con un sistema di accumulo avanzato.',
                power: '',
                icon: 'stored',
                bgColor: 'linear-gradient(180deg, #31BF01 20%, rgba(0, 0, 0, 0.30) 100%)',
                code: 'Eco_Credits_Day_Usage',
            },
            {
                img: {
                    pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709705128406/4.jpg',
                    h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709711716499/4.jpg',
                },
                title: 'Utilizzando EcoFlow PowerStream, \nhai alimentato la casa con circa [power].',
                desc: 'Goditi una casa all’insegna dell’efficienza energetica e del risparmio.',
                power: '',
                icon: 'supplied',
                bgColor: 'linear-gradient(180deg, #3F68E0 20%, rgba(0, 0, 0, 0.30) 100%)',
                code: 'Eco_Credits_Day_WN_Usage',
            },
        ] as ListType[],
    },
    es: {
        title: 'Revisa tu viaje con la energía de EcoFlow con un millón de momentos de gratitud\n¡Únete para obtener un paquete de regalo exclusivo!',
        desc: 'EcoFlow está revolucionando la experiencia energética a través de un sistema integrado que combina software y hardware de última generación. Nuestro sistema de gestión de energía (EMS) basado en la nube utiliza una aplicación fácil de usar, una interfaz web y un monitor inteligente, proporcionando mecanismos de control en diferentes escenarios y plataformas. Con funciones inteligentes y predicciones basadas en datos, nuestra solución mejora la eficiencia energética y el ahorro de costes, reformulando la experiencia energética integral.',
        nextBtn: 'Siguiente',
        items: [
            {
                img: {
                    pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709704930991/1.jpg',
                    h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709711627922/1.jpg',
                },
                title: 'Al utilizar [appliances],\nhas almacenado un total de [power]',
                desc: 'Al almacenar energía de forma proactiva para tu hogar, has proporcionado una inmensa tranquilidad a tu hogar gracias al almacenamiento de energía avanzado.',
                power: '',
                icon: 'generated',
                bgColor: 'linear-gradient(180deg, #3F68E0 20%, rgba(0, 0, 0, 0.30) 100%)',
                code: 'Eco_Credits_Day_Solar',
            },
            {
                img: {
                    pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709705023608/2.jpg',
                    h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709711650061/2.jpg',
                },
                title: 'Al usar [appliances],\nhas utilizado aproximadamente [power] de energía,',
                desc: 'haciendo que tu hogar funcione de manera rentable con un suministro de energía continuo.',
                power: '',
                icon: 'used',
                bgColor: 'linear-gradient(180deg, #FFBD3C 20%, rgba(0, 0, 0, 0.10) 100%)',
                code: 'Eco_Credits_Day_Storge',
            },
            {
                img: {
                    pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709705050961/3.jpg',
                    h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709711672442/3.jpg',
                },
                title: 'Al utilizar [appliances],\n has almacenado un total de [power].',
                desc: 'Al almacenar energía de forma proactiva para tu hogar, has proporcionado una inmensa tranquilidad a tu hogar gracias al almacenamiento de energía avanzado.',
                power: '',
                icon: 'stored',
                bgColor: 'linear-gradient(180deg, #31BF01 20%, rgba(0, 0, 0, 0.30) 100%)',
                code: 'Eco_Credits_Day_Usage',
            },
            {
                img: {
                    pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709705128406/4.jpg',
                    h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709711716499/4.jpg',
                },
                title: 'Al utilizar EcoFlow PowerStream,\nya has suministrado a tu hogar aproximadamente [power].',
                desc: 'Disfruta en tu hogar tanto de eficiencia energética como de un ahorro considerable.',
                power: '',
                icon: 'supplied',
                bgColor: 'linear-gradient(180deg, #3F68E0 20%, rgba(0, 0, 0, 0.30) 100%)',
                code: 'Eco_Credits_Day_WN_Usage',
            },
        ] as ListType[],
    },
    jp: {
        title: 'EcoFlowとの旅を振り返りましょう。以下をクリックして参加すると、ボーナスポイント（500pt）＋抽選で50名様にキャンプライトをプレゼント！',
        desc: 'EcoFlowのxxを使用してxx kWhの電気が創られました。1kWh当たり0.86ポンドのCO2削減を見積もると、あなたは合計xxxのCO2排出削減に貢献しました。持続可能性への取り組みが大きな影響を与えています。\nxxを使用することで、ご家庭で信頼性の高い電力xxx kWhを得ました。ご家庭にも環境にも優しい生活を、ぜひEcoFlow製品と共に続けてください。',
        nextBtn: '次へ',
        items: [
            {
                img: {
                    pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709704930991/1.jpg',
                    h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709711627922/1.jpg',
                },
                title: 'EcoFlowの[appliances]を使用して[power]kWhの電気が創られました',
                desc: '1kWh当たり0.86ポンドのCO2削減を見積もると、あなたは合計xxxのCO2排出削減に貢献しました。持続可能性への取り組みが大きな影響を与えています。',
                power: '',
                icon: 'generated',
                bgColor: 'linear-gradient(180deg, #3F68E0 20%, rgba(0, 0, 0, 0.30) 100%)',
                code: 'Eco_Credits_Day_Solar',
            },
            {
                img: {
                    pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709705023608/2.jpg',
                    h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709711650061/2.jpg',
                },
                title: '[appliances]を使用することで、ご家庭で信頼性の高い電力[power]kWhを得ました',
                desc: 'ご家庭にも環境にも優しい生活を、ぜひEcoFlow製品と共に続けてください。',
                power: '',
                icon: 'used',
                bgColor: 'linear-gradient(180deg, #FFBD3C 20%, rgba(0, 0, 0, 0.10) 100%)',
                code: 'Eco_Credits_Day_Storge',
            },
            {
                img: {
                    pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709705050961/3.jpg',
                    h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709711672442/3.jpg',
                },
                title: '[appliances]を活用することで、合計[power]kWhの電力を貯めました',
                desc: 'エネルギーを積極的に貯めることで、もしもの時などにもご家庭に大きな安心感をもたらすでしょう。',
                power: '',
                icon: 'stored',
                bgColor: 'linear-gradient(180deg, #31BF01 20%, rgba(0, 0, 0, 0.30) 100%)',
                code: 'Eco_Credits_Day_Usage',
            },
            // {
            //     img: {
            //         pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709705128406/4.jpg',
            //         h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709711716499/4.jpg',
            //     },
            //     title: "By utilizing [appliances],\nyou've already supplied your home with approximately [power].",
            //     desc: 'Experience both energy efficiency and savings for your household.',
            //     power: '',
            //     icon: 'supplied',
            //     bgColor: 'linear-gradient(180deg, #3F68E0 20%, rgba(0, 0, 0, 0.30) 100%)',
            //     code: 'Eco_Credits_Day_WN_Usage',
            // },
        ] as ListType[],
    },
    kr: {
        title: '멤버십데이를 함께 축하해 주세요!\n최대 40만원 (에코 포인트 + 기프트 카드 + 쿠폰)의 혜택이 주어집니다',
        desc: 'EcoFlow는 최첨단 소프트웨어와 하드웨어를 결합한 통합 시스템을 통해 에너지 경험을 혁신하고 있습니다. 클라우드 기반 에너지 관리 시스템(EMS)은 사용자 친화적인 앱, 웹 인터페이스 및 스마트 모니터에 걸쳐 다양한 시나리오와 플랫폼에 대한 제어를 제공합니다.\n 또한 데이터 기반 예측을 통해  에너지 효율성과 비용 절감을 향상시켜 엔드 투 엔드 에너지 환경을 재구성합니다.',
        nextBtn: '다음',
        items: [
            {
                img: {
                    pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709704930991/1.jpg',
                    h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709711627922/1.jpg',
                },
                title: '[appliances]제품을 사용하여,\n[power]의 전기를 생성했습니다.',
                desc: '1kWh당 0.86파운드의 탄소 절약량을 절약한다 가정했을 때, 총[carbon]의 탄소 배출량을 줄이는 데 기여했습니다',
                power: '',
                icon: 'generated',
                bgColor: 'linear-gradient(180deg, #3F68E0 20%, rgba(0, 0, 0, 0.30) 100%)',
                code: 'Eco_Credits_Day_Solar',
            },
            {
                img: {
                    pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709705023608/2.jpg',
                    h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709711650061/2.jpg',
                },
                title: '[appliances]을(를) 사용하면 \n[power]의 출력을 활용할 수 있습니다.',
                desc: '에코플로우와 함께 지속가능한 라이프를 새롭게 만들어 보세요',
                power: '',
                icon: 'used',
                bgColor: 'linear-gradient(180deg, #FFBD3C 20%, rgba(0, 0, 0, 0.10) 100%)',
                code: 'Eco_Credits_Day_Storge',
            },
            {
                img: {
                    pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709705050961/3.jpg',
                    h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709711672442/3.jpg',
                },
                title: '[appliances]을(를) 사용하여 총\n[power]의 전력을 어디로든 휴대할 수 있게 되었습니다.',
                desc: '산, 바다, 들판 어디로든 전기사용 걱정 없이 떠나보세요',
                power: '',
                icon: 'stored',
                bgColor: 'linear-gradient(180deg, #31BF01 20%, rgba(0, 0, 0, 0.30) 100%)',
                code: 'Eco_Credits_Day_Usage',
            },
            // {
            //     img: {
            //         pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709705128406/4.jpg',
            //         h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709711716499/4.jpg',
            //     },
            //     title: "By utilizing [appliances],\nyou've already supplied your home with approximately [power].",
            //     desc: 'Experience both energy efficiency and savings for your household.',
            //     power: '',
            //     icon: 'supplied',
            //     bgColor: 'linear-gradient(180deg, #3F68E0 20%, rgba(0, 0, 0, 0.30) 100%)',
            //     code: 'Eco_Credits_Day_WN_Usage',
            // },
        ] as ListType[],
    },
    za: {
        title: 'Review Power Journey with Ecoflow ，Review Million moments of gratitude\nparticipate and get  Exclusive Gift package！ worth up to R1500 !',
        desc: 'EcoFlow is revolutionizing the energy experience through an integrated system that combines cutting-edge software and hardware. Our cloud-based Energy Management System (EMS) spans a user-friendly app, web interface, and smart monitor, providing control across various scenarios and platforms. With intelligent features and data-driven predictions, our solution enhances energy efficiency and cost savings, reshaping the end-to-end energy experience.',
        nextBtn: 'Next',
        items: [
            {
                img: {
                    pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709704930991/1.jpg',
                    h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709711627922/1.jpg',
                },
                title: "By using [appliances],\nyou've generated approximately [power] of electricity",
                desc: "That's an estimated carbon saving of 390 g per kWh, you've contributed to a total reduction of [carbon] carbon emissions. Your commitment to sustainability is making a significant impact!",
                power: '',
                icon: 'generated',
                bgColor: 'linear-gradient(180deg, #3F68E0 20%, rgba(0, 0, 0, 0.30) 100%)',
                code: 'Eco_Credits_Day_Solar',
            },
            {
                img: {
                    pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709705023608/2.jpg',
                    h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709711650061/2.jpg',
                },
                title: "By using [appliances],\nyou've used approximately [power] of power,",
                desc: 'confidently running your household with a continuous energy supply.',
                power: '',
                icon: 'used',
                bgColor: 'linear-gradient(180deg, #FFBD3C 20%, rgba(0, 0, 0, 0.10) 100%)',
                code: 'Eco_Credits_Day_Storge',
            },
            {
                img: {
                    pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709705050961/3.jpg',
                    h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709711672442/3.jpg',
                },
                title: "By utilizing [appliances],\nyou've stored a total of [power].",
                desc: "Proactively storing energy for your home, you've brought immense peace of mind to your household through advanced power storage.",
                power: '',
                icon: 'stored',
                bgColor: 'linear-gradient(180deg, #31BF01 20%, rgba(0, 0, 0, 0.30) 100%)',
                code: 'Eco_Credits_Day_Usage',
            },
            {
                img: {
                    pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709705128406/4.jpg',
                    h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1709711716499/4.jpg',
                },
                title: "By utilizing Ecoflow [appliances],\nyou've already supplied your home with approximately [power].",
                desc: 'Experience both energy efficiency and savings for your household.',
                power: '',
                icon: 'supplied',
                bgColor: 'linear-gradient(180deg, #3F68E0 20%, rgba(0, 0, 0, 0.30) 100%)',
                code: 'Eco_Credits_Day_WN_Usage',
            },
        ] as ListType[],
    },
};
